import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';

import { ToastrService } from 'ngx-toastr';
import { Route, Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { inject } from '@angular/core/testing';
import { CommonService } from 'src/app/shared/services/common.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { TermAndInsuranceComponent } from 'src/app/shared/modal/term-and-insurance/term-and-insurance.component';
import { PrivacyPolicyComponent } from 'src/app/shared/modal/privacy-policy/privacy-policy.component';
import { ResetpasswordComponent } from '../resetpassword/resetpassword.component';
import { SpinnerVisibilityService } from 'ng-http-loader';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LoginComponent implements OnInit {


  hide: boolean = true;
  showLogin: boolean = true;
  passhide: boolean = true;
  cPasshide: boolean = true;
  ShowAuthDialogue: boolean = true;
  match: boolean = false;
  loginUserDetails: any;

  submitted: boolean = false;
  oneNumber: boolean = false;
  oneLowerCase: boolean = false;
  oneUpperCase: boolean = false;
  OnespecialChar: boolean = false;

  registeroneNumber: boolean = false;
  registeroneLowerCase: boolean = false;
  registeroneUpperCase: boolean = false;
  registerOnespecialChar: boolean = false;
  term: string = '';
  currentUser: any;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private toastr: ToastrService,
    private route: Router,
    public TCDialogue: MatDialog,
    private csObj: CommonService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private spinner: SpinnerVisibilityService,
    private matRef: MatDialogRef<LoginComponent>
  ) { }


  passwordRegex = /(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%&*])[\w !@#$%&*]/;
  emailreg = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  loginForm = this.fb.group({
    email: new FormControl('', [Validators.required, Validators.pattern(this.emailreg)]),
    password: new FormControl('', [
      Validators.required,
      Validators.minLength(8)
    ]),
  });




  get f() {
    return this.loginForm.controls
  }




  onClickLogin() {
    // this.spinner.show()
    // this.submitted = true;
    // this.oneNumber = false;
    // this.oneLowerCase = false;
    // this.oneUpperCase = false;
    // this.OnespecialChar = false;

    // let lowercase = /(?=.*[A-Z])/g;

    // let pass = this.loginForm.value.password;

    // let containNumber = this.containsNumbers(pass);
    // if (containNumber == false) {
    //   this.oneNumber = true;
    //   return
    // } else {
    //   this.oneNumber = false;
    // }

    // if (pass?.match(lowercase) == null) {
    //   this.oneUpperCase = true
    //   return
    // } else {
    //   this.oneUpperCase = false;
    // }

    // if (this.hasLowerCase(pass) == false) {
    //   this.oneLowerCase = true;
    //   return
    // } else {
    //   this.oneLowerCase = false;
    // }

    // if (this.containsSpecialChars(pass) == true) {
    //   this.OnespecialChar = false
    // } else {
    //   this.OnespecialChar = true;
    //   return
    // }


    if (this.loginForm.invalid) {
      return
    }

    this.submitted = false;

    let req_body = {
      "email": this.loginForm.value.email?.toLocaleLowerCase()?.trim(),
      "password": this.loginForm.value.password
    }

    this.spinner.show();

    this.authService.login(req_body).subscribe((res: any) => {

      if (res.status == 200) {
        localStorage.setItem('currentUser', JSON.stringify(res.output));
        // this.loginForm.reset();
        this.loginUserDetails = res.output;

        this.currentUser = localStorage.getItem("currentUser");
        this.currentUser = JSON.parse(this.currentUser)

        // this.userTypeValidation(this.currentUser?.userDetails?.userType);

        // alert(this.loginUserDetails?.userDetails?.userType);
        this.userTypeValidation(this.loginUserDetails?.userDetails?.userType)

        //  setTimeout(()=> {
        //   this.spinner.hide()
        //  }, 1000)

      }
      else {
        this.spinner.hide();
        this.toastr.error(res.message);
      }
    }, (err: any) => {
      this.spinner.hide();
      this.toastr.error(err.error.error.message);
    })
    // this.spinner.hide();
  }

  userTypeValidation(userType: any) {
    switch (userType) {
      case 2:
        if (this.currentUser.screen == 1) {

          // let a = document.createElement('a');
          // a.href = '/organisation/createProfile';
          // a.click();
          this.spinner.hide();
          this.matRef.close();
          this.route.navigate(['/organisation/createProfile'])

        } if (this.currentUser.screen == 2) {
          // this.matRef.close();
          // let a = document.createElement('a');
          // a.href = '/organization_dash';
          // a.click();
          this.spinner.hide();
          this.matRef.close();
          this.route.navigate(['/organization_dash'])

        } else if (this.currentUser.screen == 3) {
          // this.matRef.close();
          // let a = document.createElement('a');
          // a.href = '/organisation/addTeams';
          // a.click();
          this.spinner.hide();
          this.matRef.close();
          this.route.navigate(['/organisation/addTeams'])

        }
        break;
      case 3:
        if (this.currentUser.screen == 1) {
          // this.matRef.close();
          console.log(this.currentUser.screen);
          this.spinner.hide();
          this.matRef.close();
          this.route.navigate(['/teams/createProfile'])

        } if (this.currentUser.screen == 2) {
          // this.matRef.close();
          // let a = document.createElement('a');
          // a.href = '/team_dash';
          // a.click();
          this.spinner.hide();
          this.matRef.close();
          this.route.navigate(['/team_dash'])

        }

        break;
      case 4:
        if (this.currentUser.screen == 1) {
          this.spinner.hide();
          this.matRef.close();
          this.route.navigate(['/restaurant/createProfile'])
        } if (this.currentUser.screen == 2) {
          // this.matRef.close();
          // let a = document.createElement('a');
          // a.href = '/restaurant_dash/upcoming_orders';
          // a.click();
          this.spinner.hide();
          this.matRef.close();
          this.route.navigate(['/restaurant_dash/upcoming_orders'])
        }

        break;
      default:
      // code block
    }
  }


  containsNumbers(str: any) {
    return str.match(/\d/) !== null;
  }

  hasLowerCase(str: any) {
    return str.toUpperCase() != str;
  }

  containsSpecialChars(str: any) {
    const specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
    return specialChars.test(str);
  }


  ngOnInit(): void {
  }


  termAndCondOpen() {
    this.TCDialogue.open(TermAndInsuranceComponent);
  }

  PrivacyPolicyOpen() {
    this.TCDialogue.open(PrivacyPolicyComponent);
  }

  forgetPassClick() {
    this.TCDialogue.open(ResetpasswordComponent, {
      data: {
        userType: {
          titleOne: 'Reset Your',
          titleTwo: 'Password',
          text: "Be the MVP! Set your team up with game day meals from local restaurants with ease. Just sign up, add your events and select from a variety of restaurants. Share your team codes and you're set for the season.",
          user: this.data.userType.user,
          imgPath: '../../../assets/image/reset.png'
        }
      },
    });
  }

  checkEnterPress(e: any) {
    console.log(e.target.value);
    if (e.charCode == 13) {
      e.preventDefault();
      if (this.loginForm.invalid)
        return
      this.onClickLogin();
    }
  }

  removeSpacePhone(data: any) {
    let res = data.replaceAll(" ", '');
    return res.length
  }
}
